export const API_BASE_URL = "https://backend.ttblagnacais.fr";
// export const API_BASE_URL = "http://localhost/ttb-backend"; // Pour le dev local

export const fetchApi = async (url) => {
  const response = await fetch(`${API_BASE_URL}${url}`);

  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};

/**
 * Fonction pour récupérer les données ET les headers de réponse
 */
export const fetchApiWithHeaders = async (url) => {
  const response = await fetch(`${API_BASE_URL}${url}`);

  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();

  // Récupération des headers utiles
  const headers = {
    "X-WP-Total": response.headers.get("X-WP-Total"),
    "X-WP-TotalPages": response.headers.get("X-WP-TotalPages"),
    "Content-Type": response.headers.get("Content-Type"),
    Date: response.headers.get("Date"),
    // Ajouter d'autres headers si nécessaire
  };

  return { data, headers };
};

/**
 * Fonction pour générer des clés de requête consistantes
 */
export const createQueryKey = (endpoint, params = {}) => {
  const baseKey = endpoint.replace(/^\//, "").split("/");
  return params && Object.keys(params).length > 0
    ? [...baseKey, params]
    : baseKey;
};

/**
 * Options communes pour les requêtes qui nécessitent un cache plus long
 */
export const longCacheOptions = {
  staleTime: 30 * 60 * 1000, // 30 minutes
  cacheTime: 2 * 60 * 60 * 1000, // 2 heures
};

/**
 * Options pour les données qui changent souvent
 */
export const shortCacheOptions = {
  staleTime: 2 * 60 * 1000, // 2 minutes
  cacheTime: 10 * 60 * 1000, // 10 minutes
};

/**
 * Fonction pour récupérer les statistiques d'inscription par jour
 */
export const fetchRegistrationStats = async () => {
  const response = await fetch(
    `${API_BASE_URL}/wp-json/stage/v1/registrations-stats`,
    { cache: "no-store" },
  );

  if (!response.ok) {
    throw new Error(`API Error: ${response.status} ${response.statusText}`);
  }

  return response.json();
};
